const SPLIT_REGEX = /[,\t\n]/ug;

export default {
  data() {
    return {
      currentUsersList: [],
      newUsers: '',
      emailRules: [
        v => (v && v.every(vv => Boolean(vv))) || this.$t('mixins.formModel.label.message.error.addEmail'),
        v => (v && v.every(vv => /\S+@\S+\.\S+/u.test(vv))) || this.$t('mixins.formModel.label.message.error.addAllEmails'),
      ],
    };
  },
  methods: {
    splitUsers() {
      const areThereMultipleUsers = this.newUsers && this.newUsers.split(SPLIT_REGEX).length > 1;

      if (areThereMultipleUsers) {
        let splittedUsers = this.newUsers.split(SPLIT_REGEX);
        splittedUsers = [...new Set(splittedUsers)].filter(value => String(value).trim());

        this.currentUsersList = [...new Set(this.currentUsersList.concat(splittedUsers))];

        this.newUsers = '';
      }
    },
  },
};
